export default __webpack_public_path__ + "static/banner-mobile-tampons-1-369719276669769cbfd7b02ba05c60df.png";